<template>
	<div class="success-page" v-if="!loading && gotInitialOrderStatus">
		<slot v-if="showResidentialOrderStatus">
			<ResidentialUserNavbar
				class="desktop-center"
				:title="navbarTitle"
			/>
			<ResidentialOrderStatus />
		</slot>
		<slot v-else-if="showOrderStatus">
			<div class="order-status-navbar navbar-white">
				<Navbar
					class="desktop-center"
					:backButton="false"
					:logoSrc="$logoSrc"
				/>
			</div>
			<AirportOrderStatus v-if="showAirportOrderStatus" />
			<OrderStatus v-else />
		</slot>
		<OrderSuccess v-else />
	</div>
	<div v-else></div>
</template>

<style scoped>
.order-status-navbar {
	height: 50px;
	padding-top: 0;
}

.order-status-navbar .desktop-center {
	max-width: 700px !important;
}
</style>

<script>
import loaderMixin from "@/mixins/loader-mixin"
import Navbar from "@/components/navbars/Navbar.vue"
import OrderStatus from "@/components/success/OrderStatus.vue"
import ResidentialOrderStatus from "@/components/success/ResidentialOrderStatus.vue"
import AirportOrderStatus from "@/components/success/AirportOrderStatus.vue"
import ResidentialUserNavbar from "@/components/navbars/ResidentialUserNavbar.vue"
import OrderSuccess from "@/components/success/OrderSuccess.vue"

export default {
	name: "Success",
	mixins: [loaderMixin],
	components: {
		Navbar,
		OrderStatus,
		ResidentialOrderStatus,
		AirportOrderStatus,
		ResidentialUserNavbar,
		OrderSuccess
	},
	data: function () {
		return {
			gotInitialOrderStatus: false,
			isGuestCheckoutOrder: null
		}
	},
	computed: {
		loading() {
			return (
				!this.$store.state.business ||
				this.$store.state.business.slug != this.$route.params.slug
			)
		},
		showOrderStatus() {
			return this.$route.query.success != "true"
		},
		showResidentialOrderStatus() {
			return (
				this.$store.getters.isResidential && !this.isGuestCheckoutOrder
			)
		},
		showAirportOrderStatus() {
			return this.$store.getters.isAirport
		},
		navbarTitle() {
			return `#${this.$route.params.order_id}`
		}
	},
	created: function () {
		this.$store.dispatch("initHome", this.$route.params.slug)
		this.$store
			.dispatch("getOrderStatus", {
				orderId: this.$route.params.order_id,
				skipDeliveryStatus: true,
				deliveryJobId: null
			})
			.then(() => {
				if (
					this.$store.state.orderStatus &&
					this.$store.state.orderStatus.guest_checkout
				) {
					this.isGuestCheckoutOrder = true
				}
				this.gotInitialOrderStatus = true
			})
	},
	watch: {
		loading: {
			immediate: true,
			handler(isLoading) {
				this.toggleLoader(isLoading)
			}
		}
	}
}
</script>